import React from 'react';

import Button from '@creditflowresearch/uilib/Button';
import Modal from '@creditflowresearch/uilib/Modal';

import styles from './cancelChangesModal.module.scss';

interface IProps {
  hideCanceledModal: () => void,
  cancelChanges: () => void,
  isVisible: boolean,
  modalText?: string,
  title?: string,
  modalTitle?: string,
  discardButtonClassName?: string,
}

const CancelChangesModal = ({
  hideCanceledModal,
  cancelChanges,
  isVisible,
  title = 'Discard',
  modalTitle = 'Are you sure?',
  discardButtonClassName = styles.discardButton,
  modalText = 'Any question that has not been submitted will be discarded.',
}: IProps) => {
  const footer = (
    <>
      <Button
        variant="solid"
        color="primary"
        className={ discardButtonClassName }
        onClick={ cancelChanges }
        dataTest="discardButton"
      >
        { title }
      </Button>
      <Button
        variant="text"
        color="primary"
        onClick={ hideCanceledModal }
        dataTest="cancelButton"
      >
        Cancel
      </Button>
    </>
  );

  if (!isVisible) {
    return null;
  }

  return (
    <Modal
      className={ styles.cancelChangesModal }
      onCloseClicked={ hideCanceledModal }
      isVisible={ isVisible }
      title={ modalTitle }
      closeOnEsc={ false }
      modalBodyClassName={ styles.modalBody }
      footer={ footer }
      dataTest="cancelQuestionChangesModal"

    >
      { modalText }
    </Modal>
  );
};

export default CancelChangesModal;
